module.exports = __webpack_public_path__ + "img/rosemount-3051-in-line-pressure-transmitter-1-loi.eb05dd1e.png";